import api from '../utils/api';

/**
 * Transcribe audio using Cognitive Whisper API
 * @param {Blob} audioBlob - The audio blob to transcribe
 * @param {string} language - Language code ('es', 'en', 'pt', etc.)
 * @returns {Promise} - Promise with transcription data
 */
export const transcribeAudio = async (audioBlob, language = 'es') => {
  const formData = new FormData();
  formData.append('audio', audioBlob, 'audio.wav');
  formData.append('model', 'whisper-1');
  formData.append('language', language);

  try {
    const { data } = await api.post('cognitive/transcriptions/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return {
      text: data.text,
      success: true
    };
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Transcription failed';
    const errorCode = error.response?.status || null;
    return {
      success: false,
      errorCode,
      errorMessage,
    };
  }
};

const AudioApi = {
  transcribeAudio,
};

export default AudioApi;
